import { render, staticRenderFns } from "./EffluentsGrantingBase.vue?vue&type=template&id=147756d7&scoped=true"
import script from "./EffluentsGrantingBase.vue?vue&type=script&lang=js"
export * from "./EffluentsGrantingBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147756d7",
  null
  
)

export default component.exports